<script>
    import API from './API';
    import Util from './util';
    import {
        Swipe,
        SwipeItem
    } from './vue-swipe';

    export default {
        name: 'yyFooter',
        props: {
            biz: {
                type: String,
                required: true
            },
            showMark: {
                type: String,
                required: true
            },
            videoArea: {
                type: String,
                default: '.player'
            },
            ownername: {
                type: String,
                required: true
            },
            videourl: {
                type: String,
                required: true
            },
            toastVisible: {
                type: Boolean,
                required: true
            }
        },
        mounted() {
            this.getTinyBottomList();
            this.initScroll(this.showMark);
            if (this.ifShowFooter(this.showMark)) {
                this.footerVisible = true;
            } else {
                this.footerVisible = false;
            }
            if (document.querySelector(this.videoArea)) {
                document.querySelector(this.videoArea).addEventListener("DOMSubtreeModified", () => {
                    console.log("DOMSubtreeModified" + this.ifShowFooter(this.showMark) );
                    setTimeout(() => {
                        if (this.ifShowFooter(this.showMark)) {
                            // console.log('show');
                            this.footerVisible = true;
                        } else {
                            // console.log('hide');
                            this.footerVisible = false;
                        }
                    }, 300);
                    console.log(this.footerVisible);
                }, false);
            }
        },
        data() {
            return {
                edition: Number(Util.getURLParam('edition')) || 1,
                dataList: [],
                footerVisible: false,
            }
        },
        methods: {
            getTinyBottomList() {
                API.get('//wap.yy.com/mobileweb/bottom/getBottom', {
                        appType: this.edition ? this.edition - 1 : 0, // 手y0 狼人杀1 吃瓜2
                        biz: this.biz // 页面类型
                    })
                    .then((res) => {
                        res = JSON.parse(res);
                        this.dataList = res.data.sort(function (prev, next) {
                            return next.priority - prev.priority;
                        });
                        console.log('getTinyBottomList', this.dataList.length);
                    });
            },
            initScroll(className) {
                let scrollKey = true;
                window.addEventListener('scroll', () => {
                    if (!scrollKey) {
                        return;
                    }
                    scrollKey = false;
                    setTimeout(() => {
                        if (this.ifShowFooter(className)) {
                            this.footerVisible = true;
                        } else {
                            this.footerVisible = false;
                        }
                        scrollKey = true;
                    }, 300);
                });
            },
            ifShowFooter(className) {
                let videoMark = document.querySelector(className);
                if (videoMark) {
                    if (window.innerHeight < videoMark.getBoundingClientRect().top) {
                        return false;
                    } else {
                        return true;
                    }
                }
                return true;
                //return true;
            },
            jumpLink(type, url) {
                console.log('jumpULink', type, url, this.videourl);
                Util.hiidoReport(104);
                let jumplink = '';
                switch (type) {
                    case 0:
                        /**跳视频播放页 */
                        //console.log('jumpLink', this.videourl);
                        if (!this.videourl) {
                            if(/sv_topic/.test(window.location.href)){
                                /** 话题页去话题页 */
                                jumplink = this.gotoTopicArea();
                            }else{
                                /**  去小视频广场*/
                                jumplink = this.gotoTinyArea();
                            }
                            
                        } else if (Number(Util.getURLParam('edition')) == 2) {
                            /**调起狼人杀短视频 */
                            let schemeLink =
                                `makefriends://Shenqu/TV/D/${window.resid}/${encodeURIComponent(this.videourl)}`;
                            let rslink =
                                `//xh.yy.com/linkapp/duanpai?linkId=2&resid=${window.resid}&url=${encodeURIComponent(this.videourl)}&type=shortVideo&scheme=${encodeURIComponent(schemeLink)}`;
                            jumplink = rslink;
                        } else if (Number(Util.getURLParam('edition')) == 3) {
                            /** 吃瓜小视频 */
                            let schemeLink = `yymelon://Shenqu/TV/D/${window.resid}/${encodeURIComponent(this.videourl)}`;
                            jumplink =
                                `//ulinkmelon.yy.com/duanpai?resid=${window.resid}&url=${encodeURIComponent(this.videourl)}&type=shortVideo&edition=3&scheme=${encodeURIComponent(schemeLink)}`;
                        } else if (Number(Util.getURLParam('edition')) == 1){
                            /**调起手Y短视频 */
                            jumplink =
                                `//ulink.yy.com/duanpai?resid=${window.resid}&url=${encodeURIComponent(this.videourl)}&type=shortVideo`;
                        }
                        break;
                    case 1:
                        /**跳个人信息页H5 */
                        jumplink = url;
                        break;
                    case 2:
                        /** 调起手y*/
                        jumplink = `//ulink.yy.com/web`;
                        break;
                    case 3:
                        /**调起狼人杀 */
                        jumplink = `//xh.yy.com/linkapp/?linkId=2&scheme=makefriends%3A%2F%2F`;
                        break;
                    case 4:
                        /**西瓜小视频*/
                        jumplink = `//ulinkmelon.yy.com/?scheme=yymelon%3A%2F%2F&edition=3`;
                        break;
                }
                console.log(jumplink);
                window.location.href = jumplink;
            },
            /** 进入小视频广场 */
            gotoTinyArea: function() {
                if (window.edition == 1 ){
                    return `http://ulink.yy.com/urlscheme?action=yymobile%3A%2F%2FTinyVideo%2FSquare&type=scheme`;
                }else if (window.edition == 2 ){
                    return  `http://langrensha.yy.com/m/applink.html?linkId=2&scheme=makefriends%3A%2F%2FTinyVideo%2FSquare`;
                }else if (window.edition == 3 ){
                    return `http://ulinkmelon.yy.com/?edition=3&scheme=yymelon%3A%2F%2FTinyVideo%2FSquare`;
                }
            },
            /** 进入话题 */
            gotoTopicArea: function() {
                let schemeLink = '';
                let rslink = '';
                const id = Util.getURLParam('id');
                const edition = Number(Util.getURLParam('edition')) || 1;
                if (edition === 3) {
                    console.log('西瓜', id);
                    schemeLink = `yymelon://Shenqu/VG/D/${id}`;
                    rslink = `//ulinkmelon.yy.com?edition=3&scheme=${encodeURIComponent(schemeLink)}`;
                } else if (edition === 2) {
                    console.log('狼人杀', id);
                    schemeLink = `makefriends://Shenqu/VG/D/${id}`;
                    rslink = `//langrensha.yy.com/m/applink.html?linkId=2&scheme=${encodeURIComponent(schemeLink)}`;
                } else {
                    console.log('手Y', id);
                    schemeLink = `yymobile://Shenqu/VG/D/${id}`;
                    rslink =
                        `//langrensha.yy.com/m/applink.html?linkId=2&edition=1&scheme=${encodeURIComponent(schemeLink)}`;
                }
                return rslink;
            }
        },
        components: {
            Swipe,
            SwipeItem
        }
    }
</script>


<template>
    <transition name="slide">
        <div class="footer" id="footer" v-show="footerVisible">
            <Swipe class="footer-content" v-if="dataList.length > 0" :auto=-1>
                <Swipe-item v-for="item in dataList" key="index" :style="{ background: `url(${item.bgImg}) no-repeat`, backgroundSize: `cover` }">
                    <div class="footer-title">
                        {{ item.title }}
                    </div>
                    <div class="footer-acceptBtn" :style="{ background: `url(${item.buttonImg}) no-repeat`, backgroundSize: `100%` }" @click="jumpLink(item.jumpType, item.buttonUrl)"></div>
                </Swipe-item>
            </Swipe>
            <div class="footerdf" v-if="dataList.length == 0">
                <div class="footerdf-title">
                    <span class="footerdf-title-nick">{{ edition != 2 ? ' ' : ownername }}</span>
                    <span class="footerdf-title-txt">{{ edition == 1 ? '下载YY，获取更多精彩小视频！': edition == 2 ? '邀请你一起欢乐狼人杀' : '下载吃瓜小视频 获取更多精彩' }}</span>
                </div>
                <div class="footerdf-download" @click.stop="jumpLink(0)">{{ edition != 2 ? '下载' : '杀一局' }}</div>
            </div>
            <div  v-bind:class=" edition == 1 ? 'footer-icon yy' : edition == 2 ? 'footer-icon lr' : 'footer-icon cg'"></div>
        </div>
    </transition>
</template>

<style lang="scss">
    $font_size: 75;

    @function rem($pixels) {
        @return $pixels / $font_size+rem;
    }

    .footerdf {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        &-title {
            position: absolute;
            left: rem(28);
            bottom: 0;
            height: rem(100);
            line-height: rem(100);
            font-weight: 500;
            width: 74%;
            &-nick {
                display: block;
                font-size: rem(28);
                color: #1d1d1d;
                font-weight: bold;
                max-width: 45%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                float: left;
            }
            &-txt {
                display: block;
                font-size: rem(28);
                color: #1d1d1d;
                font-weight: bold;
                float: left;
                width: rem(430);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
        &-download {
            position: absolute;
            width: rem(160);
            height: rem(60);
            right: rem(20);
            bottom: rem(25);
            font-size: rem(28);
            color: #1d1d1d;
            text-align: center;
            line-height: rem(60);
            font-weight: bold;
            background: #ffdd00;
            border-radius: rem(50);
        }
    }

    .footer {
        position: fixed;
        bottom: 0;
        width: 100%;
        height: rem(156);
        z-index: 9999;
        &:before {
            position: absolute;
            content: '';
            width: 100%;
            height: 100%;
            background: url('./img/base64/footer-bg.png') repeat-x left top;
            background-size: auto 100%;
            left: 0;
            top: 0;
        }

        .mint-swipe-indicators {
            left: rem(40);
            bottom: rem(5);
        }
        .mint-swipe-indicator.is-active {
            background: #fde100;
            width: rem(12);
        }
        .mint-swipe-indicator {
            width: rem(6);
            height: rem(6);
        }
        div.footer-content {
            position: absolute;
            bottom: 0;
            width: 100%;
            height: rem(113);
        }
        &-title {
            float: left;
            height: rem(113);
            line-height: rem(113);
            font-weight: 500;
            width: 74%;
            font-size: rem(28);
            font-weight: bold;
            color: #1d1d1d;
            text-indent: rem(20);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        &-acceptBtn {
            float: right;
            position: relative;
            top: 50%;
            right: rem(20);
            transform: translateY(-50%);
            width: rem(160);
            height: rem(65);
            background: yellow;
        }
        &-icon {
            position: absolute;
            left: rem(0);
            width: rem(142);
            height: rem(142);
            bottom: rem(68);
            &.yy {
                background: url('./img/base64/footer-icon-yy.png') no-repeat center top;
                background-size: 100% auto;
            }
            &.lr {
                bottom: rem(70);
                background: url('./img/base64/footer-icon-lr.png') no-repeat center top;
                background-size: 100% auto;
            }
            &.cg {
                width: rem(164);
                height: rem(155);
                bottom: rem(80);
                left: rem(-8);
                background: url('./img/base64/footer-icon-cg.png') no-repeat center rem(0);
                background-size: rem(164) auto;
            }
        }
    }

    .slide-enter-active {
        animation: slide-in .5s;
    }

    .slide-leave-active {
        animation: slide-out .5s;
    }

    @keyframes slide-in {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    @keyframes slide-out {
        0% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }
</style>


// WEBPACK FOOTER //
// Footer.vue?3551747e